import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { systemAuditLogApi } from '../../../apis/SystemAuditLogApi/SystemAuditLogApi';
import { ISearchAuditLogsFilter, ISearchAuditLogsResult } from '../SystemAuditLog';

export function useSearchAuditLogs(
  filter: ISearchAuditLogsFilter
): UseQueryResult<ISearchAuditLogsResult, Error> {
  return useQuery({
    queryKey: ['auditLogs', 'search', filter],
    queryFn: async () => {
      const result = await systemAuditLogApi.searchAuditLogs(filter);
      return result;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: true, // Enable automatic requests when filter changes
  });
}
